<i18n
  src="@/locales/views/agro_exporter/certifications/providers/new_certification_review.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName(`show_${provider_type}`)"
    :params="goBackParams()"
  />

  <bread-crumbs :labels="[module_name, provider?.name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                Fecha de revisión
              </label>
              <div class="mt-1">
                <date-form v-model="reviewed_at" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowProvider()"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="create()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/certifications/providers/manage_certification_review.js";

export default {
  name: "NewCertificationReview",
  data() {
    return {
      load_general_data: false,
      provider: {},
      proc_save_button: false,
      reviewed_at: null
    };
  },
  props: {
    agro_exporter_id: { required: true },
    provider_id: { required: true },
    provider_type: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchProvider();
      this.load_general_data = true;
    },
    fetchProvider: async function () {
      let response = await Requester.fetchProvider(
        this.agro_exporter_id,
        this.provider_type,
        this.provider_id
      );

      this.provider = response.data;
    },
    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.create(
          this.agro_exporter_id,
          this.provider_type,
          this.provider_id,
          {
            reviewed_at: this.reviewed_at || ""
          }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProvider();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    goBackParams() {
      let params = {
        agro_exporter_id: this.agro_exporter_id
      };
      params[`${this.provider_type}_id`] = this.provider_id;
      return params;
    },
    goToShowProvider() {
      this.$router.push({
        name: this.routeName(`show_${this.provider_type}`),
        params: this.goBackParams()
      });
    }
  }
};
</script>
